<template>
  <div class="varieties_article">
    <!-- <el-button @click="goback()" style="marginBottom:24px;">返回</el-button> -->
    <el-descriptions
      border
      class="article"
      :column=1
      :data="tableData">
      <el-descriptions-item label="所属类别" v-if="tableData.fromtime"><div v-html="tableData.catname"></div></el-descriptions-item>
      <el-descriptions-item label="通用名称（中文）" v-if="tableData.title"><div v-html="tableData.title"></div></el-descriptions-item>
      <el-descriptions-item label="通用名称（英文）" v-if="tableData.en_title"><div v-html="tableData.en_title"></div></el-descriptions-item>
      <el-descriptions-item label="适用范围（中文）" v-if="tableData.fanwei"><div v-html="tableData.fanwei"></div></el-descriptions-item>
      <el-descriptions-item label="适用范围（英文）" v-if="tableData.en_fanwei"><div v-html="tableData.en_fanwei"></div></el-descriptions-item>
      <el-descriptions-item label="申请单位" v-if="tableData.danwei"><div v-html="tableData.danwei"></div></el-descriptions-item>
      <el-descriptions-item label="法规来源" v-if="tableData.laiyuan">
        <a :href="lyUrl[index]" target="_blank" style="display: block;" v-for="(item, index) in sourceName" :key="index">{{item}}</a>
        <a v-if="!lyUrl" target="_blank" v-html="tableData.laiyuan"></a>
      </el-descriptions-item>
      <el-descriptions-item label="批准日期" v-if="tableData.pztime"><div v-html="tableData.pztime"></div></el-descriptions-item>
      <el-descriptions-item label="实施日期" v-if="tableData.fromtime" ><div v-html="tableData.fromtime"></div></el-descriptions-item>
      <el-descriptions-item label="官网来源地址" v-if="tableData.lyurl">
        <a :href="item" target="_blank" style="display: block; word-break: break-all;" v-for="(item, index) in officialWebsiteUrl" :key="index">{{item}}</a>
      </el-descriptions-item>
      <el-descriptions-item label="备注" v-if="tableData.remark"><div v-html="tableData.remark"></div></el-descriptions-item>
    </el-descriptions>
    <el-table
      v-if="moreTableData && moreTableData.length > 0"
      :data="moreTableData"
      border
      :header-cell-style="{background:'#fafafa', color:'#333'}"
      style="width: 100%; margin-top: 24px;">
      <el-table-column
        fixed="left"
        align="center"
        prop="ty_title"
        label="通用名称（中文）"
        min-width="100px">
        <template slot-scope="scope">
          <span v-html="scope.row.ty_title"></span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="en_ty_title"
        label="通用名称（英文）"
        min-width="100px">
        <template slot-scope="scope">
          <span v-html="scope.row.en_ty_title"></span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="laiyuan"
        label="来源"
        width="120">
        <template slot-scope="scope">
          <span v-html="scope.row.laiyuan"></span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="hlgg1"
        label="含量规格（%）"
        width="180">
          <template slot-scope="scope" v-if="moreTableData[0].type == 4">
            <span v-html="scope.row.hlgg1"></span>
          </template>
        <!-- 第1个含量规格 -->
        <el-table-column
          v-if="moreTableData[0].type == 1"
          align="center"
          prop="hlgg1"
          label="以氨基酸盐计"
          width="180">
          <template slot-scope="scope">
            <span v-html="scope.row.hlgg1"></span>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="moreTableData[0].type == 2 || moreTableData[0].type == 3"
          align="center"
          prop="hlgg1"
          label="以化合物计"
          width="180">
          <template slot-scope="scope">
            <span v-html="scope.row.hlgg1"></span>
          </template>
        </el-table-column>
        <!-- 第2个含量规格 -->
        <el-table-column
          v-if="moreTableData[0].type == 1"
          align="center"
          prop="hlgg2"
          label="以氨基酸计"
          width="180">
          <template slot-scope="scope">
            <span v-html="scope.row.hlgg2"></span>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="moreTableData[0].type == 2"
          align="center"
          prop="hlgg2"
          label="以维生素计"
          width="180">
          <template slot-scope="scope">
            <span v-html="scope.row.hlgg2"></span>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="moreTableData[0].type == 3"
          align="center"
          prop="hlgg2"
          label="以元素计"
          width="180">
          <template slot-scope="scope">
            <span v-html="scope.row.hlgg2"></span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        prop="sydw"
        label="适用动物"
        width="150">
        <template slot-scope="scope">
          <span v-html="scope.row.sydw"></span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="tjyl"
        label="在配合饲料或全混合日粮中的推荐用量（%）"
        min-width="100px">
        <template slot-scope="scope">
          <span v-html="scope.row.tjyl"></span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="zgyl"
        label="在配合饲料或全混合日粮中的最高限量（%）"
        min-width="100px">
        <template slot-scope="scope">
          <span v-html="scope.row.zgyl"></span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="qtyq"
        label="其他要求"
        min-width="100px">
        <template slot-scope="scope">
          <span v-html="scope.row.qtyq"></span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tableData: {},
        url:'',
        lyUrl:'',
        moreTableData: [],
        officialWebsiteUrl:[],
        sourceName: []
      }
    },
    created () {
      // 接收varietier传过来的itemid
      this.itemid = this.$route.query.itemid
      console.log(this.itemid)
      this.initTableData();
    },
    methods: {
			toLaiyuan(){
				var host = decodeURIComponent(this.getCookie('syy_domain'))
				var host2 = this.getCookie('quanxian')
				if(host && host2 == 20){
                    console.log('登录')
					var cookie_value = this.getCookie('tjj');
					var type = this.tableData.fg_lyid?'fg':'bz'
					// var itemid = this.tableData.fg_lyid?this.tableData.fg_lyid:this.tableData.bz_lyid
                    var itemid = this.tableData.fg_lyid?this.tableData.fg_lyid.split('<br/>'):this.tableData.bz_lyid.split('<br/>');
                    var base_url;
					if(type == 'fg'){
						if (cookie_value == 1){
							// base_url = host+"/home/biaofa.biaofa_list/faguicontent?quanku=1&itemid="+itemid;
                            base_url = [];
                            for(var item in itemid){
                                base_url.push(host+"/home/biaofa.biaofa_list/faguicontent?quanku=1&itemid="+itemid[item])
                            }
						}else {
							// base_url = host+"/home/biaofa.fagui/content?quanku=1&itemid="+itemid;
                            base_url = [];
                            for(var item in itemid){
                                base_url.push(host+"/home/biaofa.fagui/content?quanku=1&itemid="+itemid[item])
                            }
						}
					}else if(type == 'bz'){
						if (cookie_value == 1){
							// base_url = host+"/home/biaofa.biaofa_list/biaozhuncontent?quanku=1&itemid="+itemid;
                            base_url = [];
                            for(var item in itemid){
                                base_url.push(host+"/home/biaofa.biaofa_list/biaozhuncontent?quanku=1&itemid="+itemid[item])
                            }
						}else {
							// base_url = host+"/home/biaofa.biaozhun/content?quanku=1&itemid="+itemid;
                            base_url = [];
                            for(var item in itemid){
                                base_url.push(host+"/home/biaofa.biaozhun/content?quanku=1&itemid="+itemid[item])
                            }
						}
					}
					this.lyUrl = base_url
				}else{
                    console.log('位登录')
					// this.lyUrl = `http://law.foodmate.net/show-${this.tableData.hbfg_lyid}.html`
                    var itemid = this.tableData.hbfg_lyid.split('<br/>');
                    var url=[];
                    for(var item in itemid){
                        url.push(`http://law.foodmate.net/show-${this.tableData.hbfg_lyid.split('<br/>')[item]}.html`)
                    }
                    this.lyUrl = url;
				}
			},
			getCookie(cookie_name) {
				// var allcookies = document.cookie;
				// //索引长度，开始索引的位置
				// var cookie_pos = allcookies.indexOf(cookie_name);
				// // 如果找到了索引，就代表cookie存在,否则不存在
				// if (cookie_pos != -1) {
				// 	// 把cookie_pos放在值的开始，只要给值加1即可
				// 	//计算取cookie值得开始索引，加的1为“=”
				// 	cookie_pos = cookie_pos + cookie_name.length + 1;
				// 	//计算取cookie值得结束索引
				// 	var cookie_end = allcookies.indexOf(";", cookie_pos);
				// 	if (cookie_end == -1) {
				// 		cookie_end = allcookies.length;

				// 	}
				// 	//得到想要的cookie的值
				// 	var value = unescape(allcookies.substring(cookie_pos, cookie_end));
				// }
				// return value;

        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${cookie_name}=`);
        if (parts.length === 2) {
          return parts[1].split(';')[0].trim(); // 取第二个元素，分割后取第一个值并去空格
        }
        return null; // 未找到
			},
      initTableData(){
        this.$ajax.get('https://api.sy.foodvip.net/?c_key=de5cd2297c84684b&func_name=additive_content&itemid=' + this.itemid,{itemid: this.itemid}).then(resp=>{
          if(resp){
            this.tableData = resp.data.data;
            this.url = resp.data.data.lyurl;
            this.officialWebsiteUrl = resp.data.data.lyurl.split('<br/>');
            this.sourceName = resp.data.data.laiyuan.split('<br/>');
            console.log(resp.data.data.gf_info);
            this.moreTableData = resp.data.data.gf_info;
						this.toLaiyuan()
          }
        })
      },
      goback(){
        this.$router.back();
      }
    },
  }
</script>

<style>
.varieties_article{
  padding: 30px 0 40px;
  min-height: auto !important;
}
a{
  color: #1966A7;
  text-decoration: none;
}
.article .el-descriptions__body{
  font-size: 14px;
  color: #333;
}
.article th{
  min-width: 180px;
  box-sizing: border-box;
}
.article .el-descriptions-item__label.is-bordered-label{
  color: #333;
  font-weight: bold;
}
.article.el-descriptions .is-bordered .el-descriptions-item__cell {
  padding: 12px 30px;
}
@media screen and (max-width: 750px) {
  .el-descriptions .is-bordered{
    table-layout: fixed;
  }
  .article th{
    width: 100px;
    min-width: auto;
  }
  .article.el-descriptions .is-bordered .el-descriptions-item__cell {
    padding: 8px 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/varieties_article.vue